const productCardMarkup = `<div class="grid grid--uniform">
  {{ #products }} 
  <div class="grid__item grid-product small--one-half medium-up--one-quarter aos-init aos-animate">
      <div class="grid-product__content">
        <a href="{{ du }}" aria-label="{{ dt }}" class="grid-product__link">
          <button
            id="swym-remove-productBtn"
            aria-label="Delete"
            data-variant-id="{{ epi }}"
            data-product-id="{{ empi }}"
            class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"/></svg>
          </button>

          <div class="grid-product__image-mask">
              <div class="grid__image-ratio grid__image-ratio--square">
                <img class="lazyautosizes lazyloaded" src="{{ iu }}">
              </div>
          </div>

          <div class="grid-product__meta">
              <div class="grid-product__title">{{ dt }}</div>
              <div class="grid-product__price">{{ cu }} {{ pr }}</div>
          </div>

          <div class="grid-product__bottom">
              <button
                id="swym-custom-add-toCartBtn"
                data-state-cart="{{#isInCart}} swym-added{{/isInCart}}"
                data-product-url="{{du}}"
                data-variant-id="{{epi}}"
                data-product-id="{{empi}}"
                class="btn swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button"
              >
                {{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
              </button>
          </div>
        </a>
      </div>
  </div>
  {{/products}}
</div>`;

function getVariantInfo(variants) {
  try {
    let variantKeys = variants && variants != "[]" ? Object.keys(JSON.parse(variants)[0]) : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-product-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart(
    {
      empi: productId,
      du: du,
    },
    variantId,
    function (c) {
      e.target.innerHTML = "Added to Cart";
      e.target.setAttribute("data-state-cart", "swym-added");
      console.log("Successfully added product to cart.", c);
    },
    function (e) {
      console.log(e);
    }
  );
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}

function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function (products) {
    console.log(products);
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
    var formattedWishlistedProducts = products.map(function (p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || p.et == _swat.EventTypes.addToCart;
      p.variantinfo = p.vi ? getVariantInfo(p.vi) : "";
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts,
    });
    if (wishlistContentsContainer) {
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      attachClickListeners();
    } else {
      console.log("Container not found, Wishlist Page element not found");
    }
  });
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  //  Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener("click", onAddToCartClick, false);
  }
  //  Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener("click", onRemoveBtnClick, false);
  }
  console.log("Events attached!");
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymRenderWishlist);
